/**
 * Created by Ning Jiang on 6/12/2019.
 */

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WinPresentationEvent} from "@nolimitcity/slot-game/bin/core/winpresentation/event/WinPresentationEvent";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PPFreespinAmbientParticles} from "../../background/PPFreespinAmbientParticles";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {PixiesVsPiratesGameModuleConfig} from "../../PixiesVsPiratesGameModuleConfig";
import {PixiesVsPiratesSoundConfig} from "../../PixiesVsPiratesSoundConfig";
import {PPReelController} from "../../reel/PPReelController";
import {PixiesVsPiratesParsedGameData} from "../../server/parseddata/PixiesVsPiratesParsedGameData";
import {PPWildSymbol} from "../../symbols/PPWildSymbol";
import {PPPickNClickOutroView} from "./PPPickNClickOutroView";

export class PPPickNClickOutroController extends FreespinOutroController {

    private _fsAmbientParticles:PPFreespinAmbientParticles;

    constructor(config:IScreenConfig) {
        super(config);
        this._fsAmbientParticles = new PPFreespinAmbientParticles(StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.FREESPIN_PARTICLES.name));
        (<PPPickNClickOutroView>this._view).getPlaySoundCallback(() => this.playOutroSounds());
    }

    private playOutroSounds():void {
        // #272
        const totalWinBelowStake: boolean = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (this._serverData!.totalWin <= (this._serverData! as PixiesVsPiratesParsedGameData).playedBetValue));
        if (!totalWinBelowStake) {
            SlotGame.sound.playEffect(PixiesVsPiratesSoundConfig.FS_OUTRO);
        }

        PixiesVsPiratesGameModuleConfig.soundPlayer.switchToMainMusic();
    }

    // Return false if it only does some restore/transition but no need to show. eg: restore in the middle of Freespin.
    protected show():boolean {
        if(this.shouldShow()) {
            this._fsAmbientParticles.startAnimation();
            this._view.show(this._serverData!, () => this.onShowComplete());
            this.hideKeypad();
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            this._isShowing = true;
        }

        return this._isShowing;
    }

    protected close():void {
        this._fsAmbientParticles.stopAnimation();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode}));
        EventHandler.dispatchEvent(new GameEvent(WinPresentationEvent.UPDATE_WIN_PRESENTATION_BET_WINS, [])); // clear wins for individual win and idle animations.
        const gameData:PixiesVsPiratesParsedGameData = <PixiesVsPiratesParsedGameData>this._serverData!;
        for(let i:number = 0; i < 6; i++) {
            const reelSize:number = gameData.gameAreaSizeEnteringFreespin[i];
            (<number[]>GameConfig.instance.STACKED_SYMBOLS!["W"].totalNum)[i] = reelSize;
            const reelSymbols:string[] = ServerDataParser.parseStackedSymbolsInReel(gameData.rawReelsEnteringFreespin[i], i);
            const reel:PPReelController = <PPReelController>Reels.getReel(i);
            reel.resetReelSymbols(reelSize, reelSymbols); // it will be the after nudge symbols so no need to handle unfinished w.
        }
        (<PixiesVsPiratesParsedGameData>this._serverData).wildMultipliersEnteringFreespin.forEach((multiplier:number, reelId:number) => {
            if(multiplier > 0) {
                const symbol:PPWildSymbol = <PPWildSymbol>Reels.getSymbol(reelId, 5);
                if(!(symbol instanceof PPWildSymbol)) {
                    Logger.logDev(`PPPickNClickOutroController.close():Cannot find restored wild on reel ${reelId}`);
                    debugger;
                }
                symbol.updateMultiplier(multiplier, false);
            }
        });
        for(let j:number = 1; j < 5; j++) {
            (<number[]>GameConfig.instance.STACKED_SYMBOLS!["W"].totalNum)[j] = 3;
            (<PPReelController>Reels.getReel(j)).reelSize = 3;
        }

        super.close();
    }

    protected onCloseComplete():void {
        Logger.logDev(`Close Screen ${this.moduleName}`);

        SlotGame.keypad.setZeroBetSpinCounter(-1);
        this.showKeypad();
        SlotGame.winFieldController.showWinField();
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED));
    }
}